export default "__VITE_ASSET__PDAH2mFl__"